/* istanbul ignore file */
// TODO: Create test file

import {
  ref, computed, watch,
} from 'vue';
import { warn } from '@core/util/clientlogger';

const SCRIPT_BINDING_COMPLETE = 'complete';
const SCRIPT_BINDING_FAILED = 'failed';
const SCRIPT_BINDING_LOADING = 'loading';

export default function useContextualIntegration({ isBrandData, isEnabled }) {
  const count = ref(0);
  const firstBind = ref(true);
  const sfContextualWidgetBindFunc = ref(null);

  const sfScriptStatus = ref(!isBrandData?.value ? '' : SCRIPT_BINDING_COMPLETE);

  const scriptComplete = computed(() => sfScriptStatus.value === SCRIPT_BINDING_COMPLETE);
  const scriptFailed = computed(() => sfScriptStatus.value === SCRIPT_BINDING_FAILED);
  const scriptIsLoading = computed(() => sfScriptStatus.value === SCRIPT_BINDING_LOADING);

  const loadScript = () => {
    if (!isBrandData.value) {
      count.value = 0;
      sfScriptStatus.value = SCRIPT_BINDING_LOADING;
    }
  };

  const bindContextualExpToDOM = (addCount = false) => {
    const bindScriptToWidget = addCount ? (scriptIsLoading.value && count.value < 30) : scriptIsLoading.value;
    const bindScriptLimitReached = addCount ? (scriptIsLoading.value && count.value === 30) : scriptIsLoading.value;

    if (bindScriptToWidget) {
      try {
        window.sf_widget.utils.registerContextualService();
        sfScriptStatus.value = SCRIPT_BINDING_COMPLETE;
      } catch (error) {
        warn('Salesfloor window object is not yet available');
        sfScriptStatus.value = addCount ? SCRIPT_BINDING_LOADING : SCRIPT_BINDING_FAILED;
      }
    } else if (bindScriptLimitReached) {
      sfScriptStatus.value = SCRIPT_BINDING_FAILED;
    }

    if (addCount) {
      count.value += 1;
    }
  };

  if (!isBrandData.value) {
    watch(sfScriptStatus, () => {
      if ((scriptComplete.value || scriptFailed.value) && !!sfContextualWidgetBindFunc.value) {
        clearInterval(sfContextualWidgetBindFunc.value);
        sfContextualWidgetBindFunc.value = null;
      } else if (scriptIsLoading.value && firstBind.value) {
        sfContextualWidgetBindFunc.value = setInterval(bindContextualExpToDOM.bind(null, firstBind.value), 500);
        firstBind.value = false;
      } else if (scriptIsLoading.value && !firstBind.value) {
        bindContextualExpToDOM(firstBind.value);
      }
    });

    if (isEnabled) {
      watch(isEnabled, (status) => {
        if (!status) {
          sfScriptStatus.value = '';
        }
      });
    }
  }
  return {
    scriptComplete,
    scriptFailed,
    scriptIsLoading,
    disableWidgetClass: computed(() => ({ 'disable-sf-widget': scriptIsLoading.value })),
    loadScript,
  };
}
